import React from "react";
import standardInputWrapper from "../../standard-input-wrapper/standard-input";
import FormRadioSelect from "../../../form/radio-select/form-radio-select";

const SCAT5InputRadio = standardInputWrapper(FormRadioSelect);

export default SCAT5InputRadio;
